<div [class]="teamCode + '-skin'">
<main-header [team]="team"></main-header>

<div class="main-container ">
	<router-outlet></router-outlet>
</div>

<!-- <main-footer [team]="team"></main-footer> -->
</div>
